import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgCheckFilled = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><Path fill="currentColor" d="M20.571 0H3.43A3.429 3.429 0 0 0 0 3.429V20.57A3.429 3.429 0 0 0 3.429 24H20.57A3.429 3.429 0 0 0 24 20.571V3.43A3.429 3.429 0 0 0 20.571 0Z" /></Svg>;
const Memo = memo(SvgCheckFilled);
export default Memo;